import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export { formatTimeAgo } from './time-utils';
export { logBusinessAction } from './audit-utils';

export function formatCurrency(amount: number): string {
  const formatNumber = (num: number) => {
    const formatted = num.toFixed(2);
    // Remove .00 or trailing zeros after decimal
    return formatted.replace(/\.00$/, '').replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
  };

  if (amount >= 1000000000) {
    return `$${formatNumber(amount / 1000000000)}B`;
  } else if (amount >= 1000000) {
    return `$${formatNumber(amount / 1000000)}M`;
  } else if (amount >= 1000) {
    return `$${formatNumber(amount / 1000)}K`;
  } else {
    const formatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount);
    // Remove .00 from currency formatted values
    return formatted.replace(/\.00$/, '');
  }
}
